import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-list',
  templateUrl: './skeleton-list.component.html',
  styleUrls: ['./skeleton-list.component.css']
})
export class SkeletonListComponent {
  constructor() {}
}
